

export const getLoggedInUser = async () => {
	try {
		const response = await fetch('api/User/LoggedInUser');

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return response.json();
	} catch (error) {
		console.error(`Failed to get logged in user, error:`, error);
		throw error;
	}
};